import { TransitionData } from '@wix/thunderbolt-becky-types'

const getCSSFromTransitionItem = (styleItem: TransitionData) => {
	const property = 'all'
	const { 'timing-function': timingFunction = 'ease', duration = 0, delay = 0 } = styleItem
	return `transition: ${property} ${duration}s ${timingFunction} ${delay}s`
}

export { getCSSFromTransitionItem }
